import { Link } from "react-router-dom";
import { Stars } from "./Stars";
import { formatINR } from "../lib/api";

export function ProductCard({ product, eager = false }) {
    const cover = (product.images && product.images[0]) || "";
    const hasCompare = product.compareAtPrice && product.compareAtPrice > product.price;

    return (
        <Link
            to={`/product/${product.slug}`}
            className="product-card group block"
            data-testid={`product-card-${product.slug}`}
        >
            <div className="product-card-image rounded-2xl">
                {cover ? (
                    <img
                        src={cover}
                        alt={product.name}
                        loading={eager ? "eager" : "lazy"}
                        onError={(e) => { e.currentTarget.style.opacity = 0.5; }}
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-inkMuted">No image</div>
                )}
                <div className="absolute" />
                <div className="relative">
                    <div className="absolute -mt-10 ml-3 flex flex-col gap-1">
                        {product.isNew ? (
                            <span className="bg-ivory/95 text-inkDark text-[10px] tracking-[0.2em] uppercase px-2.5 py-1 rounded-full shadow-soft">New</span>
                        ) : null}
                        {product.isBestSeller ? (
                            <span className="bg-skyblue/95 text-inkDark text-[10px] tracking-[0.2em] uppercase px-2.5 py-1 rounded-full">Bestseller</span>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="pt-4 pb-2">
                <div className="font-serif text-[1.05rem] text-inkDark leading-tight group-hover:text-skyblueDeep transition-colors line-clamp-1">
                    {product.name}
                </div>
                {product.subType ? (
                    <div className="label-eyebrow mt-1 text-[10px]">{product.subType}</div>
                ) : product.fabric ? (
                    <div className="label-eyebrow mt-1 text-[10px]">{product.fabric}</div>
                ) : null}
                <div className="mt-2 flex items-baseline gap-2">
                    <span className="font-medium text-inkDark" data-testid={`product-price-${product.slug}`}>{formatINR(product.price)}</span>
                    {hasCompare ? (
                        <span className="text-inkMuted text-sm line-through">{formatINR(product.compareAtPrice)}</span>
                    ) : null}
                </div>
                {product.reviewCount > 0 ? (
                    <div className="mt-1 flex items-center gap-1.5 text-xs text-inkMuted" data-testid={`product-card-rating-${product.slug}`}>
                        <Stars rating={product.avgRating} size={11} />
                        <span>({product.reviewCount})</span>
                    </div>
                ) : null}
            </div>
        </Link>
    );
}
